import { SearchCondition } from './search-condition.model';
import { MatchingFilter } from './matching-filter.model';
export class AutoSearchConditionGroup {
  auto: SearchCondition;
  worker: SearchCondition;
  project: SearchCondition;
  matching_filters: Array<MatchingFilter>;
  constructor(hash: any) {
    this.auto = hash.auto || new SearchCondition({});
    this.worker = hash.worker || new SearchCondition({});
    this.project = hash.project || new SearchCondition({});
    this.matching_filters = hash.matching_filters || [];
  }
}
